import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { CircleLoader, ClockLoader, GridLoader, RingLoader, RotateLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { BiMoneyWithdraw } from "react-icons/bi";
import { InventorySupplyModal } from "../components/supply_modal";
import { InventoryDeductModal } from "../components/deduct_modal";
import { MdDeleteForever, MdOutlineWarehouse } from "react-icons/md";
import {LiaTimesSolid} from "react-icons/lia";
import { useCart } from "../hooks/add_to_cart"
import { ItemDetails } from "../components/product_details_walkin";
import { CompleteSale } from "../components/complete_walkin_sale";
import { PiCashRegisterBold } from "react-icons/pi";
import { TostMessageContext } from "../context/TostMessage";
import { FaLink } from "react-icons/fa";
import { IoIosLink } from "react-icons/io";


export default function WalkIns() {
    const [pageLoading, setPageLoading] = useState(true);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount, clearCart } = useCart();
    const [offset, setOffset] = useState(0);
    const [pagination, setPagination] = useState({total_product: 0})
    const [categoryFilter, setCatFilter] = useState([]);
    const [subCategoryFilter, setSubCatFilter] = useState([]);
    const {state} = useLocation();
    const [sortBy, setSortBy] = useState(state?.sort ?? '');
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [subCategories, setSubCat] = useState([]);
    const [searchParam, setSearchParam] = useState('');
    const [cookies] = useCookies();
    const [cartItems, setCartItems] = useState(Array.isArray(cookies?.myCart) ? cookies.myCart : []);
    const [showCompleteSale, setShowCompleteSale] = useState(false);
    const {setTostMessage} = useContext(TostMessageContext);
    const [generatingLink, setGeneratingLink] = useState(false);
    const {logOutFunction} = useContext(UserContext);

    useEffect(() => {
        getData();
    }, [])
    
    useEffect(() => {
        setCartItems(Array.isArray(cookies?.myCart) ? cookies.myCart : []);
    }, [cookies?.myCart])

    const calculateItemPrice = (item) => {
        const extrasTotal = Object.values(item.selected || {}).reduce(
        (sum, opt) => sum + Number(opt.amount_plus),
        0
        );

        return item.total_price;
    };

    const subtotal = cartItems?.reduce(
        (sum, item) => sum + calculateItemPrice(item),
        0
    );
    

    function changePage() {
        setOffset(products?.length);
    }

    useEffect(() => {
        getData();
    }, [offset])

    useEffect(() => {
        resetData();
        setOffset(0);
    }, [sortBy, searchParam])

    async function resetData() {
        const formData = new FormData();
        formData.append('offset', 0);
        formData.append('sortBy', sortBy);
        formData.append('category_filter', JSON.stringify(categoryFilter));
        formData.append('sub_category_filter', JSON.stringify(subCategoryFilter));
        formData.append('searchParam', searchParam);
        try {
            const response = await axios.post(base_url + '/fetch_shop_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                setProducts(response.data.data);
                setPagination({ total_product: response.data.total_count })
                setSubCat(response.data.sub_categories);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function getData() {
        const formData = new FormData();
        formData.append('offset', offset);
        formData.append('sortBy', sortBy);
        formData.append('category_filter', JSON.stringify(categoryFilter));
        formData.append('sub_category_filter', JSON.stringify(subCategoryFilter));
        formData.append('searchParam', searchParam);

        try {
            const response = await axios.post(base_url + '/fetch_shop_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setProducts([...products, ...response.data.data]);
                setPagination({ total_product: response.data.total_count })
                setSubCat(response.data.sub_categories);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    const addFilter = (value, category) => {
        const array = categoryFilter;
        const index = array.findIndex(
            item => item === category
        );
        if (index != -1) {
            array.splice(index, 1);
            setCatFilter(array);
        } else {
            array.push(category);
            setCatFilter(array);
        }
        resetData();
    }

    const addSubFilter = (value, category) => {
        const array = subCategoryFilter;
        const index = array.findIndex(
            item => item === category
        );
        if (index != -1) {
            array.splice(index, 1);
            setSubCatFilter(array);
        } else {
            array.push(category);
            setSubCatFilter(array);
        }
        resetData();
    }

    async function shareLink() {
        setGeneratingLink(true)
        const formData = new FormData();
        formData.append('cart_data', JSON.stringify(cartItems));

        try {
            const response = await axios.post(base_url + '/share-payment-link.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                await navigator.clipboard.writeText(response.data.payment_link);
                setTostMessage({
                    messageType: 'success',
                    message: 'Payment link copied to clipboard, proceed to share to customer'
                })
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: 'Unable to generate payment link at the moment, please try again later'
                })
            }
            setGeneratingLink(false)
        } catch (error) {
            setTostMessage({
                messageType: 'error',
                message: 'Network error! Unable to generate payment link at the moment'
            })
            setGeneratingLink(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
    {showModal &&
        <ItemDetails 
            setShowModal={setShowModal}
            showModal={showModal}
            showDetails={showDetails}
        />
    }
    {showCompleteSale &&
        <CompleteSale
            showCompleteSale={showCompleteSale}
            setShowCompleteSale={setShowCompleteSale}
        />
    }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="gap-y-2 md:gap-y-0 flex flex-col mt-3 md:mt-0 md:flex-row md:items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Checkout'}</h2>
                <div className="flex items-center self-end">
                    {/* <div className="w-auto flex items-center justify-between border rounded-xl p-2 gap-x-2">
                        <div onClick={() => { }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{'Check Out'}</div>
                    </div> */}
                </div>
            </div>
            <div className="w-full mx-auto px-0 py-6">
                <div className="flex flex-col-reverse md:flex-row gap-6">
                    <div className="flex-1">
                        <div className="flex justify-between items-center mb-4">
                            <p className="text-sm text-gray-600">
                            Showing 1 - {products?.length} out of {pagination?.total_product} Products
                            </p>
                            {/* <select selected={sortBy} value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="border px-2 py-1 text-sm">
                                <option value="">Default</option>
                                <option value="New Arrivals">New Arrivals</option>
                                <option value="Best Sellers">Best Sellers</option>
                                <option value="price-low">Price: Low to High</option>
                                <option value="price-low">Price: High to Low</option>
                            </select> */}
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-6">
                            {products.map((i, index) => (
                                <div key={index} className="text-sm">
                                    <div 
                                    onClick={() => {setShowModal(true);setShowDetails({ name: i.name, product_id: i.id }) }} 
                                    style={{ backgroundImage: `url(${i.image})` }}
                                    className="cursor-pointer bg-cover bg-center h-[15em] md:h-[10em] mb-3" />
                                    <p className="font-medium">{i.name}</p>
                                    <p className="text-gray-500">{i.starts_from}</p>
                                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-2">
                                        <p className={`${i.in_stock > 1 ? 'text-[#00b47a]' : 'text-[#ff0000]'} text-sm italic`}>{i.in_stock} unit(s) left</p>
                                        <div className="flex flex-col">
                                            {/* <button onClick={() => i.in_stock > 0 ? addToCart(i.id, 'product', 1) : null} className="text-md underline">
                                            + Add to Cart
                                            </button> */}
                                            <button className="text-md underline">
                                            {i.category_name}
                                            </button>
                                            
                                            {checkItemInCart(i.id) > 0 &&
                                                <a onClick={() => removeItem(i.id)} className="cursor-pointer text-sm text-gray-500 flex items-center gap-x-1"><LiaTimesSolid color="#585858" size={13} /> {checkItemInCart(i.id)} added</a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="mx-auto flex items-center justify-center my-5">
                            <button onClick={() => changePage()} className="border rounded-md border-[#bbbbbb] py-2 px-5 text-[#222222]">Show more products</button>
                        </div>
                    </div>
                    <aside className="relative md:sticky md:top-10 h-[min-content] block w-full md:w-[300px] bg-white p-4 border rounded">
                        <FilterGroup title="Search by Product">
                            <input
                                className="w-full bg-gray-100 rounded px-4 py-2 mt-1"
                                value={searchParam}
                                placeholder="Enter product name..."
                                onChange={(e) => setSearchParam(e.target.value)}
                            />
                        </FilterGroup>

                        <FilterGroup title="Categories">
                            {cookies?.userProfile?.categories?.map(b => (
                            <label key={b.id} className="flex items-center gap-2 mb-1 md:mb-0 text-sm mr-2 md:mr-0">
                                <input onChange={(e) => addFilter(e.target.checked, b.id)} type="checkbox" /> {b.name}
                            </label>
                            ))}
                        </FilterGroup>

                        <FilterGroup title="Collections">
                            {subCategories?.map((b, index) => 
                            <label key={b.id} className="flex items-center gap-2 mb-1 md:mb-0 text-sm mr-2 md:mr-0">
                                <input onChange={(e) => addSubFilter(e.target.checked, b.id)} type="checkbox" /> {b.name}
                            </label>
                            )}
                        </FilterGroup>
                        
                        <hr className="mb-5"/>

                        <FilterGroup title="Selected Products">
                        <p className="text-underline underline self-end text-sm cursor-pointer" onClick={() => clearCart()}>Clear</p>
                        <ol>
                        {cartItems?.map((item, index) => (
                            <li className="flex flex-row gap-x-2 mb-1">
                                <button onClick={() => removeItem(item.product_id)}>
                                    <MdDeleteForever color="#ff0000" />
                                </button>
                                <p className="text-sm">{item.quantity}x {item.name}</p>
                                <p className="text-sm font-medium">{convertAmount(item.total_price)}</p>
                            </li>
                        ))}
                        </ol>
                        <div className="w-full flex justify-between font-semibold text-lg mt-3">
                            <span>Total</span>
                            <span>{convertAmount(subtotal)}</span>
                        </div>
                        <div className="w-full mt-5 w-auto flex flex-col items-center justify-between border rounded-xl p-2 gap-y-2">
                            <div onClick={() => { setShowCompleteSale(true) }} className="gap-x-2 w-full flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#00b47a] bg-[#00b47a] text-white font-semibold text-center text-xs"><PiCashRegisterBold size={20} />{'Complete Sale'}</div>
                            <div className="text-center mx-auto w-full"><label>or</label></div>
                            <div onClick={() => shareLink() } className="gap-x-2 w-full flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{generatingLink ? <ClockLoader
                                color={'#ffffff'}
                                loading={generatingLink}
                                size={20}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            /> : <IoIosLink size={20} />}{'Share Payment Link'}</div>
                        </div>
                        </FilterGroup>
                    </aside>
                </div>
            </div> 
        </div>
    </div>
  );
}

function FilterGroup({ title, children }) {
  return (
    <div className="mb-3 md:mb-6">
      <h4 className="font-semibold mb-2">{title}</h4>
      <div className="flex flex-wrap md:flex-col md:space-y-2">{children}</div>
    </div>
  )
}